<template>
	<svg
		width="14"
		height="2"
		viewBox="0 0 14 2"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0.75 0.75H12.75"
			stroke="#D9D9D9"
			stroke-width="1.5"
			stroke-linecap="round"
		/>
	</svg>
</template>
